import {lazy} from "react";
import {Route} from "react-router-dom";
import {controlPanelRoutes} from "@/routes/ProtectedRoutes/controlPanelRoutes";
import {ordersRoutes} from "@/routes/ProtectedRoutes/ordersRoutes";
import {knowledgeBaseRoutes} from "@/routes/ProtectedRoutes/knowledgeBaseRoutes";
import {
    applicationsForChangePersonalDataRoutes
} from "@/routes/ProtectedRoutes/applicationsForChangePersonalDataRoutes";
import {bannerRoutes} from "@/routes/ProtectedRoutes/bannerRoutes";
import {appealsRoutes} from "@/routes/ProtectedRoutes/appealsRoutes";
import {referenceBooksRoutes} from "@/routes/ProtectedRoutes/referenceBooksRoutes";
import {statisticsRoutes} from "@/routes/ProtectedRoutes/statisticsRoutes";
import {profileRoutes} from "@/routes/ProtectedRoutes/profileRoutes";
import {notificationLogsRoutes} from "@/routes/ProtectedRoutes/notificationLogsRoutes";
import UrlsConfig from "@/config/UrlsConfig";

const NotAuthenticatedChecker = lazy(() => import("@/routes/Checkers/NotAuthenticatedChecker/NotAuthenticatedChecker"));
const FirstEntryBlocker = lazy(() => import("@/routes/Checkers/FirstEntryBlocker"));

const DynamicPage = lazy(() => import("@/routes/DynamicPage"));
const ErrorSandbox = lazy(() => import("@/pages/DevTools/ErrorSandbox/ErrorSandbox"));

const urlsConfig = new UrlsConfig();

export function protectedRoutes() {
    return (
      <Route element={<NotAuthenticatedChecker/>}>
          <Route element={<FirstEntryBlocker/>}>
              {controlPanelRoutes()}
              {profileRoutes()}
              {ordersRoutes()}
              {knowledgeBaseRoutes()}
              {applicationsForChangePersonalDataRoutes()}
              {bannerRoutes()}
              {appealsRoutes()}
              {referenceBooksRoutes()}
              {notificationLogsRoutes()}
              {statisticsRoutes()}

              <Route path={urlsConfig.errorSandbox.to} element={<ErrorSandbox/>}/>

              {/* DYNAMIC (menu) */}
              <Route path="*" element={<DynamicPage/>}/>
          </Route>
      </Route>
    );
}
